import { Icon, IconProps } from './Icon';

export type SearchProps = IconProps;

export const Search = (props: SearchProps) => (
  <Icon width="17px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" {...props}>
    <path d="m14.25 14-4-4m1.333-3.333a4.667 4.667 0 1 1-9.333 0 4.667 4.667 0 0 1 9.333 0Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
